/*** 一所图像/职鉴 ***/
import { http } from '@/api/http';
const config = require('@/config');

export default {
    // 数据埋点
    trackFiscanUrl: `${config.baseUrl}/api/Track/Fiscan`,

    /**
     * FiscanPaper 职鉴考卷
     */
    // 获取职鉴图像知识点库存
    getFiscanImageStock(data) {
        return http.get('/api/FiscanPaper/ImageStock', data);
    },
    getFiscanPaperDetail(id) {
        return http.get(`/api/FiscanPaper/${id}`);
    },
    // 提交职鉴图像考卷
    postAutoFiscanPaper(data) {
        return http.post('/api/FiscanPaper/Automatic', data);
    },
    queryFiscanPackage(data) {
        return http.get('/api/FiscanPackage/Query', data);
    },
    // 在组卷过程中生成fiscan image
    addFiscanImageInPaper(data) {
        return http.post('/api/FiscanPaper/Gen', data);
    },

    /**
     * 职鉴考试相关
     */
    saveFiscanExam(id, data) {
        return http.post(`/api/Exam/Save/Fiscan/${id}`, data, { noShowError: true });
    },
    submitFiscanExam(id, data) {
        return http.post(`/api/Exam/Submit/Fiscan/${id}`, data);
    },

    saveFiscanMockExam(id, guid, data) {
        return http.post(`/api/MockExam/Save/Fiscan/${id}/${guid}`, data, { noShowError: true });
    },
    submitFiscanMockExam(id, guid, data) {
        return http.post(`/api/MockExam/Submit/Fiscan/${id}/${guid}`, data);
    },


    /**
     * FiscanIStudy 职鉴练习相关
     */
    // 学员查询自己的职鉴练习记录
    queryFiscanStudy() {
        return http.get('/api/FiscanIStudy/Query')
    },
    // 开始职鉴练习
    startFiscanPractice(data) {
        return http.get('/api/FiscanIStudy/Practise', data);
    },
    // 提交职鉴练习
    submitFiscanPractice(guid, form, data) {
        return http.post(`/api/FiscanIStudy/Submit/${guid}/${form}`, data);
    },
    // 提交练习后调用，获得本次练习的作答概况
    fiscanPracticeAchievement(id) {
        return http.get(`/api/FiscanIStudy/Achievement/${id}`);
    },
    // 获取练习详情
    fiscanPracticeDetail(id) {
        return http.get(`/api/FiscanIStudy/FiscanDetails`, {guid: id});
    },
    // 练习记录详情
    getFiscanPracticeDetail(id) {
        return http.get(`/api/FiscanIStudy/Achievement/${id}`);
    },
    // 练习统计中查询学员的职鉴练习情况
    getFiscanExciseStats(data) {
        return http.get('/api/FiscanIStudy/GetFiscanStudyQuery', data);
    },
    queryFiscanExciseStatsDetail(id, data) {
        return http.get(`/api/FiscanIStudy/UserQuery/${id}`, data);
    },

    getFiscanTopicDetail(id) {
        return http.get(`/api/FiscanTopic/${id}`);
    },

    /**
     * FiscanImageStatistics 元素图像统计
     */
    fiscanStatsByIdentification() {
        return http.get('/api/FiscanImageStatistic/ByFiscanInageIsIdentification')
    },
    fiscanStatsByKnowledge() {
        return http.get('/api/FiscanImageStatistic/ByFiscanImageKnowledge')
    },
    fiscanStatsByProduct() {
        return http.get('/api/FiscanImageStatistic/ByFiscanImageProduct')
    },

    /**
     * FiscanPackageStatistics 包裹图像统计
     */
    fiscanPackageStatsByIdentification() {
        return http.get('/api/FiscanPackageStatistic/ByIsIdentification')
    },
    fiscanPackageStatsByKnowledge() {
        return http.get('/api/FiscanPackageStatistic/ByKnowledge')
    },
    fiscanPackageStatsByProduct() {
        return http.get('/api/FiscanPackageStatistic/ByProduct')
    },
    fiscanPackageStatsByTipCount() {
        return http.get('/api/FiscanPackageStatistic/ByTipCount')
    },
    fiscanPackageStatsByEmpty() {
        return http.get('/api/FiscanPackageStatistic/ByEmptyPercentage')
    },
}


